import { ThemeOptions } from "@mui/material";
import { typographyVariants } from "../constants";

export const muiInput: ThemeOptions["components"] = {
  MuiInput: {
    defaultProps: {
      disableUnderline: true,
    },
    styleOverrides: {
      input: props => ({
        "&::placeholder": {
          color: props.theme.palette.secondary.light,
          opacity: 1,
        },
      }),
      root: ({ theme }) => ({
        ...typographyVariants.body,
        color: theme.palette.text.primary,
        minHeight: "32px",
      }),
    },
  },
};
